import { render, staticRenderFns } from "./PopupCard.vue?vue&type=template&id=a7901fbc&scoped=true&"
import script from "./PopupCard.vue?vue&type=script&lang=ts&"
export * from "./PopupCard.vue?vue&type=script&lang=ts&"
import style0 from "./PopupCard.vue?vue&type=style&index=0&id=a7901fbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7901fbc",
  null
  
)

export default component.exports